// extracted by mini-css-extract-plugin
export default {"managerInfo":"Outcome_managerInfo__jq6-a"};